import React from 'react';
import styled from '@emotion/styled';
import { contentWidthPc } from 'style/variables';
import sizes from 'style/sizes';
import { TextButton } from 'components/atoms/textButton';

type ProjectsBackToWrapBottomProps = {
  to: string;
};

const Container = styled.div`
  padding-top: ${sizes.margin[120]};
  padding-bottom: ${sizes.margin[48]};
  display: flex;
  justify-content: center;
  max-width: ${contentWidthPc}px;
  margin: auto;
`;

export const ProjectsBackToWrapBottom: React.FC<ProjectsBackToWrapBottomProps> = props => {
  return (
    <Container>
      <TextButton arrowDirection={'left'} to={props.to}>
        Back to Index
      </TextButton>
    </Container>
  );
};
